// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__6BtIs","logoMark":"logo_logoMark__5d3oY","logoText":"logo_logoText__3ExdY"};